// src/components/Clientes.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

import "../layouts/Clientes.css";

import Titulo from "../assets/pc/aliados/titulo3.png";
import Slide1 from "../assets/pc/aliados/set1.png";
import Slide2 from "../assets/pc/aliados/set2.png";
import Slide3 from "../assets/pc/aliados/set3.png";
import Slide4 from "../assets/pc/aliados/set4.png";
import Slide5 from "../assets/pc/aliados/set5.png";

import Slide1R from "../assets/celu/aliados/Slide_1.png";
import Slide2R from "../assets/celu/aliados/Slide_2.png";
import Slide3R from "../assets/celu/aliados/Slide_3.png";
import Slide4R from "../assets/celu/aliados/Slide_4.png";
import Slide5R from "../assets/celu/aliados/Slide_5.png";

let Slidex1 = Slide1
let Slidex2 = Slide2;
let Slidex3 = Slide3;
let Slidex4 = Slide4;
let Slidex5 = Slide5;
const isMobile = window.innerWidth < 768;
if (isMobile) {
   Slidex1 = Slide1R;
   Slidex2 = Slide2R;
   Slidex3 = Slide3R;
   Slidex4 = Slide4R;
   Slidex5 = Slide5R;
}

const slides = [Slidex1, Slidex2, Slidex3, Slidex4, Slidex5];

export default function Clientes() {
    const settings = {
      dots: true,
      dotsClass: "slick-dots custom-dots",
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      color: "#000",
      autoplay: true,
      autoplaySpeed: 4000,
    };

  return (
    <section className="cliente-section" id="section1">
      <div className="cliente-titulo">
        <img src={Titulo} alt="Título de Clientes" />
      </div>
      <div className="slider-wrapper">
        <Slider {...settings}>
          {slides.map((src, idx) => (
            <div key={idx} className="slide-item">
              <img src={src} alt={`Slide ${idx + 1}`} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
